import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateService,
} from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams) {
    const trans: TranslateService = params.translateService;
    const key: string = params.key.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const curTranslations: Record<string, string> =
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      trans.translations[trans.currentLang] || {};

    if (!curTranslations) {
      return params.key.toUpperCase();
    }

    const keys: string[] = Object.keys(curTranslations);
    // Direct key lookup instead of using translate.instant()
    const matchingKey = keys.find((element) => element.toLowerCase() === key);
    if (matchingKey) {
      const value = curTranslations[matchingKey];
      trans.set(params.key, value);
      return value;
    }

    const error = new Error(`Translation missing: ${params.key}`);
    error.name = 'TranslationMissingError';
    Object.assign(error, {
      currentLang: trans.currentLang,
      defaultLang: trans.defaultLang,
      availableKeys: keys.length,
    });

    console.error('Translation error:', error);
    Sentry.captureException(error);

    if (
      params.translateService.currentLang ===
      params.translateService.defaultLang
    ) {
      return params.key.toUpperCase();
    } else {
      return params.key;
    }
  }
}
